function applyRules(product) {
  const { sales, stock, price } = product;

  // RULE 1
  if (sales < 5 && stock > 50) {
    return {
      status: "CRITICAL",
      reason: "Low sales with high inventory indicates potential loss",
      action: "Reduce price or increase promotion",
      confidence: 0.85,
    };
  }

  // RULE 2
  if (stock < 10 && sales > 20) {
    return {
      status: "CRITICAL",
      reason: "High demand with low stock risks stockout",
      action: "Refill inventory urgently",
      confidence: 0.9,
    };
  }

  // RULE 3
  if (sales > 30 && price === "high") {
    return {
      status: "OPPORTUNITY",
      reason: "Strong sales despite high price",
      action: "Maintain price or test slight increase",
      confidence: 0.8,
    };
  }

  // RULE 4
  if (sales >= 10 && sales <= 30 && stock >= 20 && stock <= 100) {
    return {
      status: "STABLE",
      reason: "Balanced demand and inventory",
      action: "No action required",
      confidence: 0.7,
    };
  }

  // FALLBACK
  return {
    status: "STABLE",
    reason: "No specific rule matched",
    action: "No action",
    confidence: 0.6,
  };
}

export default applyRules;